import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import { Button } from '@mui/material';
class ImageUpload extends Component {
    constructor(props) {
        super(props);
        //this.state = { file: '', imagePreviewUrl: '' };
        if (props.value) //if store has value relative to this component, initialize the state value
            this.state = { ...this.state, value: props.value, imagePreviewUrl: props.imagePreviewUrl };
        else //in case the store does not have any value for this component, just clear it
            this.state = { ...this.state, value: "", imagePreviewUrl: "" };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.value)//if store's value relative to this component change, update the state value
            this.setState({ value: newProps.value });
        else if (!newProps.value)//in case the store does not have any value for this component, just clear it
            this.setState({ value: "" });

        if (newProps.imagePreviewUrl && newProps.imagePreviewUrl !== this.state.imagePreviewUrl)
            this.setState({ imagePreviewUrl: newProps.imagePreviewUrl });
    }

    _handleImageChange(e) {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({
                value: file,
                imagePreviewUrl: reader.result
            });
            this.props.dispatch({ type: types.FORM_INPUT, value: reader.result, name: this.props.name });
        };

        reader.readAsDataURL(file);
    }

    handleRemoveImage() {
        this.setState({
            value: null,
            imagePreviewUrl: null
        });
        this.props.dispatch({ type: types.FORM_INPUT, value: null, name: this.props.name });
    }

    render() {
        let { imagePreviewUrl, value } = this.state;
        let $imagePreview = null;
        if (imagePreviewUrl || value) {
            $imagePreview = (<div className="product-upload-img"><img src={imagePreviewUrl || value} /></div>);
        } else {
            $imagePreview = null;
        }

        const styles = {
            uploadButton: {
                verticalAlign: 'middle'
            },
            uploadInput: {
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                width: '100%',
                opacity: 0
            }
        };
        return (
            <div className="row">
                <div className="col-xs-12 p-0">
                    <Button
                        component="label"
                        dx={{ ...styles.uploadButton }}
                        variant="contained"
                        className="pull-left"
                        style={{ marginTop: 12 }}
                    >
                        {this.props.text ? this.props.text : "Upload Image"}
                        <input className="fileInput"
                            type="file"
                            style={styles.uploadInput}
                            accept={this.props.accept ? this.props.accept : ''}
                            onChange={(e) => this._handleImageChange(e)} />
                    </Button>
                    {this.props.isInternalMessageImg ?
                        <Button
                            component="label"
                            sx={{ backgroundColor: "#afaeb3", color: "#fff" }}
                            className="ml-1"
                            style={{ marginTop: 12 }}
                            onClick={() => this.handleRemoveImage()}
                        >Remove Image</Button>
                        : null}
                </div>
                {this.props.displayPreview && <div className="col-xs-12 p-0 mt-3">
                    {$imagePreview}
                </div>}
            </div>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        value: state.form[props.name],
        imagePreviewUrl: state.form && state.form.imagePreviewUrl && state.form.imagePreviewUrl[props.name],
        displayPreview: props.displayPreview !== undefined ? props.displayPreview : true
    };
}

export default connect(mapStatetoProps)(ImageUpload);
